import { Connection, ObjectType, EntitySchema, ConnectionOptions, createConnection } from 'typeorm'
import { TestConnectionOptionsFactory } from './ConnectionOptionsFactory'

export function makeOpenTestDB(opts: Partial<ConnectionOptions>) {
  const factory = new TestConnectionOptionsFactory(opts)
  return async (name: string) => {
    const opts = {
      ...factory.make(),
      name
    }
    const conn = await createConnection(opts)
    return conn
  }
}

export async function closeTestDB(conn: Connection) {
  if (!conn) {
    throw new Error(`blank connection: ${conn}`)
  }

  // https://stackoverflow.com/questions/16375542/in-sqlite3-is-there-a-foreign-key-integrity-check
  // sqlite 에서 FK 검증 끄면 테이블 날릴때
  // 테이블 간의 의존성을 신경쓰지 않아도 된다
  await conn.query('PRAGMA foreign_keys = OFF;')

  const metadatas = conn.entityMetadatas
  const names = metadatas.map(m => m.name).reverse()

  for (const name of names) {
    try {
      await deleteDB(conn, name)
    } catch (err) {
      console.error(`closeTestDB failed: name=${name} err=${err}`)
    }
  }

  await conn.query('PRAGMA foreign_keys = ON;')

  await conn.close()
}

async function deleteDB<Entity>(
  conn: Connection,
  target: ObjectType<Entity> | EntitySchema<Entity> | string
) {
  await conn.getRepository(target).clear()
}
